module.exports = __webpack_public_path__ + "static/media/not-accessible.5a6d6713.svg";